import React from "react";
import { Card, Avatar, Tag, Progress, Row, Col, Popconfirm, Button, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { InfoCircleOutlined } from "@ant-design/icons";

// Credit Score / Risk Grades
const riskGrades = [
  { grade: "F", label: "Critical", range: "0-349", color: "#e977773f", textColor: "#ef4444" },
  { grade: "D", label: "Poor", range: "350-499", color: "#f974163a", textColor: "#f97316" },
  { grade: "C", label: "Average", range: "500-649", color: "#f59f0b3f", textColor: "#f59e0b" },
  { grade: "B", label: "Good", range: "650-799", color: "#22c55e3c", textColor: "#22c55e" },
  { grade: "A", label: "Excellent", range: "800-1000", color: "#13c2c233", textColor: "#13c2c2" },
];

const riskLevelStyles = {
  "Low Risk": {
    color: "#13c2c233",
    textColor: "#13c2c2",
  },
  "Medium Risk": {
    color: "#f59f0b3f",
    textColor: "#f59e0b",
  },
  "High Risk": {
    color: "#ef44443c",
    textColor: "#ef4444",
  },
};



const UserCard = ({ user, onChangeStatus, current_page, search_query_value, search_query_key }) => {
  const navigate = useNavigate();
  const riskScore = user?.risk_score ?? 0;
  const level = user?.risk_level || "Low Risk";
  const levelStyle = riskLevelStyles[level] || riskLevelStyles["Low Risk"];


  return (
    <Card
      style={{
        borderRadius: 16,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        position: "relative",
      }}
      bodyStyle={{ padding: 20, paddingTop: 30 }}
    >
      {/* 🔹 Top Right Button */}
      <Button
        size="small"
        type="primary"
        style={{ position: "absolute", top: 12, right: 12, borderRadius: 6 }}
        onClick={() => {

          localStorage.setItem(
            "user_page",
            current_page
          );

          localStorage.setItem(
            "user_search",
            search_query_value
          );

          localStorage.setItem(
            "user_search_key",
            search_query_key
          );

          navigate("/users-camp/" + btoa(user?.id));
        }}
      >
        Campaigns
      </Button>

      {/* 🔹 User Info */}
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <Avatar
          size={56}
          style={{
            backgroundColor: levelStyle.color,
            color: levelStyle.textColor,
            fontWeight: "bold",
            border: `2px solid ${levelStyle.color}`,
          }}
        >
          {user?.name?.slice(0, 2)?.toUpperCase()}
        </Avatar>

        <div>
          <div style={{ fontSize: 18, fontWeight: 600 }}>{user?.name}</div>
          <div style={{ color: "#8c8c8c" }}>{user?.email}</div>

          <div style={{ marginTop: 6 }}>
            <Tag>{user?.organization || "IT"}</Tag>
            <Tag>{user?.designation || "user"}</Tag>
          </div>
        </div>
      </div>

      <div style={{ margin: "16px 0", borderTop: "1px solid #f0f0f0" }} />

      {/* 🔹 Risk */}
     <div style={{ display: "flex", justifyContent: "space-between" }}>
  <span
    style={{
      display: "flex",
      alignItems: "center",
      gap: 4,
    }}
  >
    Risk Score

    {/* <Tooltip
      title="Your Risk Score starts at 1000 and decreases when you click phishing links or submit sensitive information during phishing simulations. A higher score indicates better security awareness."
      color="#fff"
      overlayInnerStyle={{
        color: "#000",
        border: "1px solid #d9d9d9",
        maxWidth: 280,
      }}
    >
      <InfoCircleOutlined
        style={{
          color: "#999",
          cursor: "pointer",
          fontSize: 14,
        }}
      />
    </Tooltip> */}
  </span>

  <span style={{ fontWeight: 600, color: levelStyle.textColor }}>
    {riskScore}
  </span>
</div>

      <Progress
        percent={riskScore / 10}
        showInfo={false}
        strokeColor={levelStyle.textColor}
        trailColor="#f0f0f0"
      />

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
        <Tag
          style={{
            backgroundColor: levelStyle.color,
            color: levelStyle.textColor,
            borderRadius: 8,
            border: "none",
          }}
        >
          {level}
        </Tag>
        <span style={{ color: "#8c8c8c" }}>
          Susceptibility: {user?.susceptibility || 0}%
        </span>
      </div>

      {/* 🔹 Actions (Smaller Cards) */}
      <Row gutter={8} style={{ marginTop: 14 }}>
        <Col span={12}>
          <Card
            size="small"
            bodyStyle={{ padding: 8 }}
            className="edit-card"
            onClick={() => {

              localStorage.setItem(
                "user_page",
                current_page
              );

              localStorage.setItem(
                "user_search",
                search_query_value
              );

              localStorage.setItem(
                "user_search_key",
                search_query_key
              );

              navigate("/edit-user/" + btoa(user?.id));
            }}
          >
            <div  style={{
    color: "#13C2C2",
    fontSize: "14px",
    fontWeight: 700,
    textAlign: "center",
  }}>Edit</div>
          </Card>
        </Col>

        <Col span={12}>
          <Card
            size="small"
            bodyStyle={{ padding: 8 }}
            className={user?.status ? "status-card-active" : "status-card-inactive"}
          >
            <Popconfirm
              title="Are you sure to change status?"
              onConfirm={() => onChangeStatus(user?.id)}
            >
              <div style={{ fontWeight: 700, textAlign: "center" , fontSize: "14px",}}>
                {user?.status ? "Active" : "Inactive"}
              </div>
            </Popconfirm>
          </Card>
        </Col>
      </Row>
    </Card>
  );
};

export default UserCard;